const inboxPositions = new Set(['Asistent', 'Zam', 'Manager', 'Control'])

export function canUseTelegramBotInbox(user: { normalized_position?: string | null; normalized_positions?: string[] | null } | null | undefined): boolean {
  return [user?.normalized_position, ...(user?.normalized_positions || [])].some(position => position && inboxPositions.has(position))
}
